import React from "react";

import "./index.scss";

const DeleteRowIcon = () => (
  <svg
    id="Delete_Row_Dark_Theme_"
    data-name="Delete Row (Dark Theme)"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    className="delete-row-icon"
  >
    <rect id="Margin" className="delete-row-icon--rect" width="32" height="32" />
    <circle id="Ellipse_284" data-name="Ellipse 284" className="delete-row-icon--circle" cx="7.5" cy="7.5" r="7.5" transform="translate(8.5 8.5)" />
    <line id="Line_212" data-name="Line 212" className="delete-row-icon--line" x2="8" transform="translate(12 16)" />
  </svg>
);

export default DeleteRowIcon;
